import styled from 'styled-components';

export const StyledFieldset = styled.fieldset`
  position: relative;
  margin: 0;
  padding: 0;
  border: none;
`;
